import PropTypes from 'prop-types';

import GenericFormContainer from '../Forms/GenericFormContainer';

import NoteComponent from './NoteComponent';

import {
  validatePhoneNumber,
  lengthValidation250,
  required,
  validateEmail,
} from '../Forms/utils';

import { STYLED_TEXT } from '../Forms/fieldTypes';

const LeasingComponent = (props) => {
  const { onSubmit, validate, form, notes, initialValues } = props;

  const formData = [
    {
      keyName: 'renterName',
      label: 'Name',
      fieldType: STYLED_TEXT,
      validate: [required, lengthValidation250],
    },
    {
      keyName: 'email',
      label: 'Email',
      fieldType: STYLED_TEXT,
      validate: [validateEmail],
    },
    {
      keyName: 'phoneNumber',
      label: 'Phone Number',
      fieldType: STYLED_TEXT,
      validate: [validatePhoneNumber],
    },
    {
      keyName: 'notes',
      label: 'Notes',
      fieldType: STYLED_TEXT,
      multiline: true,
      validate: [],
      disabled: true,
      isHidden: true,
    },
  ];

  return (
    <>
      <NoteComponent note={notes} />
      <GenericFormContainer
        form={form}
        formData={formData}
        onSubmit={onSubmit}
        validate={validate}
        initialValues={initialValues}
        title="Prospective tenant/buyer form"
        backButton={false}
        isFullWidthForm
        isFullWidthSubmit
      />
    </>
  );
};

LeasingComponent.defaultProps = {
  validate: () => {},
  notes: null,
};
LeasingComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.string.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  validate: PropTypes.func,
  notes: PropTypes.string,
};

export default LeasingComponent;
